import Token from '~/components/Token'

export interface ITradeTokenSelector {
  onClick?: () => void
  needApprove?: boolean
  token: BaseTokenlonToken
}

export const TradeTokenSelect: React.FC<ITradeTokenSelector> = ({
  token,
  needApprove,
  onClick,
}) => {
  return (
    <>
      <Token token={token} onClick={onClick} needApprove={needApprove} />
    </>
  )
}
